<template>
  <div :key="refresh">
    <v-card class="mx-1 elevation-0 rounded-0">
      <v-card-title class="pt-0 mt-0">
        <v-row>
          <v-col class="mx-auto" :style="$vuetify.breakpoint.name !== 'xs' && mode === 'More' ? 'max-width: 265px': ''">
            <v-row :class="$vuetify.breakpoint.name !== 'xs' ? mode === 'More' ? 'ml-n4 d-flex flex-column' : '' : 'mt-n2 mb-6'">
              <v-col class="mr-12 mb-n2">
                <v-row class="d-flex flex-nowrap mx-auto" style="margin-top: -2px; padding-bottom: 2px">
                  <button-tip btnclass="ml-n4 mr-1 mt-2" @click="getItemsForThisFirm(firm.fid)" elevation="5" fab icolor="black"
                              iname="mdi-update" tip="Refresh Policies" xsmall/>
                  <v-btn-toggle
                    class="ml-0 mr-0 px-0"
                    color='secondary darken-2'
                    group
                    small
                    v-model="view"
                  >
                    <v-btn class="caption px-1 mx-1" value="View" style="min-width:24px">
                      View
                    </v-btn>
                    <v-btn class="caption px-1 mx-1" value="View All" style="min-width:24px">
                      All
                    </v-btn>
                    <v-btn class="caption px-1 mx-1" value="Policies">
                      Policies
                    </v-btn>
                    <v-btn class="caption px-1 mx-1" value="Quotes">
                      Quotes
                    </v-btn>
                  </v-btn-toggle>
                  <v-btn-toggle
                    class="ml-n2 mr-4 px-0"
                    color='secondary darken-2'
                    group
                    small
                    v-model="mode"
                  >
                    <v-btn class="caption px-2 ml-0 mr-12" value="Less" v-if="mode === 'More'" style="min-width:11px">
                      <v-icon small>mdi-minus</v-icon>
                    </v-btn>
                    <v-btn class="caption mr-12" value="More" v-else style="min-width:20px">
                      <v-icon small>mdi-plus</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-row>
              </v-col>
              <v-col>
                <v-row class="mt-1 d-flex flex-nowrap align-center" :style="$vuetify.breakpoint.xs ? 'padding-right: 20px;' : ''">
                  <!-- 12 Feb 2026 JCH: stabilize xs Search/Create spacing to avoid button clipping -->
                  <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" clearable dense
                                style="min-width: 140px; flex: 1 1 auto;"
                                single-line hide-details class="pl-1 mr-1 flex-grow-1"></v-text-field>
                  <!-- 12 Feb 2026 JCH: keep Create button visible on xs, tighter spacing on sm+ -->
                  <button-tip :btnclass="$vuetify.breakpoint.xs ? 'ml-0 mr-12' : 'ml-0 mr-3'" @click="openCreatePolicyDialog" color="secondary" elevation="5" fab icolor="white"
                              iname="mdi-plus" :tip="'Create\u00A0Policy'" v-can="'policy-edit'" xsmall/>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" md="7" lg="8" xl="9" class="pa-0 pt-2 mx-auto"
                 v-if="mode === 'More'"
                 style="height:160px; overflow-y: scroll; background-color: whitesmoke">
              <v-autocomplete
                  class="px-3 mb-n2"
                  clearable
                  @input="statusSelected=true"
                  @click:clear="statusSelected=true"
                  dense
                  :items="$_lists.pstatus"
                  placeholder="Status"
                  :menu-props="{ maxHeight: 450 }"
                  multiple
                  style="padding-top: 4px"
                  v-model="status"
              >
                <template v-slot:selection="{ item }">
                  <span class="caption"> {{ item.text }} &nbsp </span>
                </template>
              </v-autocomplete>
              <v-autocomplete
                  class="px-3 mb-n2"
                  clearable
                  dense
                  :items="$_lists.carrier"
                  placeholder="Carrier"
                  :menu-props="{ maxHeight: 450 }"
                  multiple
                  style="margin-bottom: 11px"
                  v-model="carrier"
              >
                <template v-slot:selection="{ item }">
                  <span class="caption"> {{ item }} &nbsp </span>
                </template>
              </v-autocomplete>
              <v-autocomplete
                  class="px-3"
                  clearable
                  dense
                  :items="$_lists.ptype"
                  placeholder="Type"
                  :menu-props="{ maxHeight: 450 }"
                  multiple
                  style="margin-top: -5px"
                  v-model="type"
              >
                <template v-slot:selection="{ item }">
                  <span class="caption"> {{ item }} &nbsp </span>
                </template>
              </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-title>
    </v-card>
    <v-data-table class="px-1 elevation-0 lessPadding rounded-0"
                  ref="policiesTable"
                  :class="tableClass"
                  @click:row="rowClick"
                  dense
                  fixed-header
                  :headers="colHeaders"
                  hide-default-footer
                  :item-class="policyRowClass"
                  item-key="pid"
                  :items="policiesFiltered"
                  :items-per-page="-1"
                  :loading="loading"
                  loading-text="Data loading... Please wait..."
                  :mobile-breakpoint="0"
                  multi-sort
                  :search="search"
                  single-select
                  :sort-by="['type', 'incept']"
                  :sort-desc="[false, true]"
                  :style="$_cssVars"
    >
      <template v-slot:item.actions="{ item }">
        <v-lazy>
          <div>
            <button-tip btnclass="ml-0 mr-n1" @click="$_editPolicy(item.pid)" icon iname="mdi-pencil" tip="Edit Policy" v-can="'policy-edit'"/>
            <button-tip btnclass="ml-n1" @click="viewPolicy(item)" icon iname="mdi-eye-outline" tip="View Policy"/>
            <v-menu open-on-hover offset-y close-on-content-click>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small icon v-bind="attrs" v-on="on">
                  <v-icon class="mr-3">mdi-calculator</v-icon>
                </v-btn>
              </template>

              <v-list>
                <div>
                  <v-list-item v-for="(feature, index) in calculationFeatures" :key="index" @click="feature.action(item)"
                               v-if="!feature.scope || $_can(feature.scope)">
                    <v-list-item-title>{{ feature.title }}</v-list-item-title>
                  </v-list-item>
                </div>
              </v-list>
            </v-menu>
          </div>
        </v-lazy>
      </template>
      <template v-slot:item.carrier="{ item }">
        <v-tooltip left v-if="item.carrier && item.carrier.length > 12">
          <template v-slot:activator="{ on }">
            <div style="cursor: pointer" v-on="on">
              {{ item.carrier ? item.carrier.slice(0, 9) + '...' : '' }}</div>
          </template>
          {{ item.carrier || '' }}
        </v-tooltip>
        <div v-else>{{ item.carrier || '' }}</div>
      </template>
      <template v-slot:item.incept="{ item }">{{date(item.incept)}}</template>
      <template v-slot:item.expiry="{ item }">{{date(item.expiry)}}</template>
      <template v-slot:item.retro="{ item }">{{date(item.retro)}}</template>
      <template v-for="field in currencyFieldVals" v-slot:[`item.${field}`]="{ item }">
        {{ item[field] || item[field] === 0 ? `$${(parseFloat(item[field])).toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,')}` : '' }}
      </template>
    </v-data-table>

    <v-dialog v-model="createPolicyDialog" persistent max-width="600" :key="refreshCreatePolicy">
      <v-card>
        <v-card-title>Create Policy</v-card-title>

        <v-card-text :class="$vuetify.breakpoint.xs ? 'px-2 pt-2 pb-3' : 'pa-6 pt-2'">
          <v-row :class="$vuetify.breakpoint.xs ? 'px-1 mx-0 my-1' : 'px-3 mx-1 my-2'">
            <v-col cols="12" :class="$vuetify.breakpoint.xs ? 'px-1 py-0' : 'px-2 py-0'">
              <v-menu
                v-model="programMenuOpen"
                :close-on-content-click="false"
                offset-y
                content-class="program-picker-menu-content"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="program-picker-field"
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    append-icon="mdi-menu-down"
                    :value="programSearchRaw"
                    label="Program"
                    :style="{ width: '100%', fontSize: '14px' }"
                    @click="onProgramFieldInteract"
                    @input="onProgramSearchInput"
                    @click:clear="clearProgramSelection"
                    @keydown.down.prevent="onProgramArrow(1)"
                    @keydown.up.prevent="onProgramArrow(-1)"
                    @keydown.enter.prevent="onProgramEnter"
                    @keydown.esc.prevent="programMenuOpen = false"
                    @click:append="programMenuOpen = !programMenuOpen"
                    :class="{ 'program-picker-field--open': programMenuOpen }"
                  />
                </template>
                <v-card :class="{ 'program-picker-loading-state': programsLoading }">
                  <div v-if="programsLoading" class="program-picker-loading-row px-3 py-2 d-flex align-center">
                    <v-progress-circular indeterminate size="18" width="2.5" color="secondary" class="mr-2" />
                    Programs loading...
                  </div>
                  <v-virtual-scroll
                    v-if="filteredProgramOptions.length"
                    ref="programVirtualScroll"
                    :items="filteredProgramOptions"
                    :height="programVirtualHeight"
                    :item-height="programOptionHeight"
                    :bench="8"
                  >
                    <template v-slot:default="{ item, index }">
                      <div
                        class="program-picker-option d-flex align-center px-3"
                        :class="{ 'program-picker-option--active': index === programActiveIndex }"
                        :style="{
                          fontSize: $vuetify.breakpoint.xs ? '11px' : '',
                          letterSpacing: $vuetify.breakpoint.xs ? '-0.15px' : ''
                        }"
                        @mouseenter="programActiveIndex = index"
                        @mousedown.prevent
                        @click="selectProgramOption(item)"
                      >
                        <div v-if="programOptionNeedsHtml(item)" v-html="highlightProgramOption(item)"></div>
                        <div v-else>{{ item.text }}</div>
                      </div>
                    </template>
                  </v-virtual-scroll>
                  <div
                    v-else-if="!programsLoading"
                    class="program-picker-empty-row px-3 py-2 body-2 d-flex align-center"
                    :style="{ fontSize: $vuetify.breakpoint.xs ? '11px' : '' }"
                  >
                    No data available
                  </div>
                </v-card>
              </v-menu>
            </v-col>
          </v-row>
          <v-row :class="$vuetify.breakpoint.xs ? 'px-1 mx-0 my-1' : 'px-3 mx-1 my-2'">
            <v-col cols="12" :class="$vuetify.breakpoint.xs ? 'px-1 py-1' : 'px-2 py-1'">
              <DatePickerFormatted
                clearable
                :date-formatted-prop="policyToCreate.incept"
                label="Incept"
                menu-wrapper
                input-color="secondary"
                picker-color="secondary"
                picker-context-label="Incept"
                :style="{ width: '100%', fontSize: '14px' }"
                format="MM-DD-YYYY"
                format-loosely-valid="M-D-YYYY"
                v-model="policyToCreate.incept"
              />
              <div class="d-flex align-center justify-start mt-n7 mb-0 ml-n2">
                <button-tip btnclass="ma-0 mr-1 pa-0" icon iname="mdi-information-outline" ismall
                            tip="When Create Policy opens, Incept defaults to today (MM-DD-YYYY). Changing Incept auto-updates Retro (same date) and Expiry (+1 year), unless you manually edited Retro or Expiry. All date fields remain editable."/>
                <span class="ml-n1 caption">Incept updates Retro/Expiry unless edited.</span>
              </div>
            </v-col>
            <v-col cols="12" :class="$vuetify.breakpoint.xs ? 'px-1 py-1' : 'px-2 py-1'">
              <DatePickerFormatted
                clearable
                :date-formatted-prop="policyToCreate.expiry"
                label="Expiry"
                menu-wrapper
                input-color="secondary"
                picker-color="secondary"
                picker-context-label="Expiry"
                :style="{ width: '100%', fontSize: '14px' }"
                format="MM-DD-YYYY"
                format-loosely-valid="M-D-YYYY"
                @input="onCreateDateInput('expiry', $event)"
                v-model="policyToCreate.expiry"
              />
            </v-col>
            <v-col cols="12" :class="$vuetify.breakpoint.xs ? 'px-1 py-1' : 'px-2 py-1'">
              <DatePickerFormatted
                clearable
                :date-formatted-prop="policyToCreate.retro"
                label="Retro"
                menu-wrapper
                input-color="secondary"
                picker-color="secondary"
                picker-context-label="Retro"
                :style="{ width: '100%', fontSize: '14px' }"
                format="MM-DD-YYYY"
                format-loosely-valid="M-D-YYYY"
                @input="onCreateDateInput('retro', $event)"
                v-model="policyToCreate.retro"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="mx-6"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="createPolicyDialog = false">Cancel</v-btn>
          <v-btn color="secondary" :disabled="!canCreatePolicy" @click="createPolicy">Create Policy</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <tax-dialog v-if="taxDialog" :fid="firm.fid" :pid="taxPid" v-model="taxDialog"/>
    <commissions-dialog v-if="commissionsDialog" :pid="comPid" v-model="commissionsDialog" />
  </div>
</template>

<script>
  import moment from 'moment';
  import { FirmsAPIService } from "@/servicehandlers/FirmsAPIService";
  import { ListsAPIService } from '@/servicehandlers/ListsAPIService';
  import TaxDialog from '@/components/taxes/TaxDialog';
  import ViewPolicy from '@/components/search/firms/ViewPolicy';
  import CommissionsDialog from "../../commissions/CommissionsDialog";
  import {PoliciesAPIService} from "@/servicehandlers/PoliciesAPIService";
  import { ProgramsAPIService } from "@/servicehandlers/ProgramsAPIService";
  import VirtualPickerMixin from "@/mixins/VirtualPickerMixin";

  const apiService = new FirmsAPIService();
  const listsAPIService = new ListsAPIService();
  const policiesAPIService = new PoliciesAPIService();
  const programsAPIService = new ProgramsAPIService();

  export default {
    name: "FirmPoliciesTable",
    mixins: [VirtualPickerMixin],
    props: {
      firm: Object,
      notPopup: Boolean,
      default() {
        return {};
      }
    },
    components: { CommissionsDialog, TaxDialog, ViewPolicy },
    data() {
      return {
        carrier: [],// selected carriers
        carriers: [],// all carriers
        calculationFeatures: [
          {title: 'Taxes', action: (x) => this.openTaxDialog(x)},
          {title: 'Commissions', action: (x) => this.openCommissionsDialog(x), scope: 'calculate-commissions'}
        ],
        comPid: '',
        commissionsDialog: false,
        createPolicyDialog: false,
        createPolicyManual: { expiry: false, retro: false },
        createPolicyItems: [],
        currencyFieldVals: ['premium','taxes','fees','total','down'],
        errors: [],
        loading: false,
        mode: 'Less',
        newPolicyPid: null,
        pendingEditPolicyPid: null,
        policies: [],
        policiesFiltered: [],
        policy: {},
        policyToCreate: {},
        programOptions: [],
        programsByPrid: {},
        programSearchRaw: '',
        programSearchApplied: '',
        programMenuOpen: false,
        programActiveIndex: -1,
        programOptionHeight: 40,
        programVirtualHeight: 320,
        keepProgramMenuOpenAfterLoad: false,
        selectedProgram: null,
        programsLoaded: false,
        programsLoading: false,
        refresh: false,
        refreshCreatePolicy: false,
        search: '',
        showDatePicker: false,
        status: [],
        statusAllNames: [],
        statuses: [],
        statusSelected: false,
        tableClass: '',
        taxDialog: false,
        taxPid: '',
        type: '',
        types: [],
        view: 'View',// value for displaying initial default policies
      }
    },

    mounted () {// initialize tableClass
      this.tableClass = !this.notPopup ? 'popupLargeTableNoFooter' : 'largeSizeTableNoFooter';
      this.lists = this.$store.getters.lists;
    },

    computed: {
      canCreatePolicy() {
        // 12 Feb 2026 JCH: gate submit until required fields are present and valid dates.
        const required = ['prid', 'incept', 'expiry', 'retro'].every((field) => !!this.policyToCreate[field]);
        if (!required) return false;
        return ['incept', 'expiry', 'retro'].every((field) => this.isValidCreateDate(this.policyToCreate[field]));
      },
      colHeaders() {
        let dateWidth = '94px';
        let nonCurrencyFields = [
          // columns for testing
          // {value: 'grpnum',text: 'grpnum',sortable: true, align: 'start', width: '92px' },
          // {value: 'prid',text: 'prid',sortable: true, align: 'start', width: '92px' },
          // {value: 'status',text: 'status',sortable: true, align: 'start', width: '92px' },
          // {value: 'pid',text: 'pid',sortable: true, align: 'start', width: '92px' },

          // {value: 'submitted',text: 'submitted',sortable: true, align: 'start', width: '92px' },
          // {value: 'quoted',text: 'quoted',sortable: true, align: 'start', width: '92px' },
          // {value: 'bndreq',text: 'bndreq',sortable: true, align: 'start', width: '92px' },
          // {value: 'booked',text: 'booked',sortable: true, align: 'start', width: '92px' },
          // {value: 'bound',text: 'bound',sortable: true, align: 'start', width: '92px' },
          // {value: 'issued',text: 'issued',sortable: true, align: 'start', width: '92px' },
          // {value: 'canceled',text: 'canceled',sortable: true, align: 'start', width: '92px' },

          {value: 'actions', text: 'Actions',sortable: false,align: 'center',width: '98px' },
          {value: 'carrier', text: 'Carrier',sortable: true, align: 'start', width: '92px' },
          {value: 'type',    text: 'Type',   sortable: true, align: 'start', width: this.colWidth },
          {value: 'status',  text: 'Status', sortable: true, align: 'start', width: '58px'  },
          {value: 'incept',  text: 'Incept', sortable: true, align: 'start', width: dateWidth },
          {value: 'expiry',  text: 'Expiry', sortable: true, align: 'start', width: dateWidth },
          {value: 'retro',   text: 'Retro',  sortable: true, align: 'start', width: dateWidth },
          {value: 'limits',  text: 'Limits', sortable: true, align: 'center',width: '104px'   },
          {value: 'deduc',   text: 'Deduc',  sortable: true, align: 'end',   width: '78px' },
        ]
        return [...nonCurrencyFields, ...this.currencyFields];
      },
      colWidth() {
        return !this.notPopup ? '48px' : '98px';
      },
      currencyFields() {
        let amountWidth = '70px';
        return [
          {value: 'premium', text: 'Premium',sortable: true, align: 'end', width: '72px' },
          {value: 'taxes',   text: 'Tax',    sortable: true, align: 'end', width: '68px' },
          {value: 'fees',    text: 'Fees',   sortable: true, align: 'end', width: amountWidth },
          {value: 'total',   text: 'Total',  sortable: true, align: 'end', width: amountWidth },
          {value: 'down',    text: 'Down ',  sortable: true, align: 'end', width: amountWidth },
        ];
      },
      selectedProgramOption() {
        const prid = this.policyToCreate && this.policyToCreate.prid;
        if (!prid) return null;
        return this.programOptions.find((option) => option.value === prid) || null;
      },
      filteredProgramOptions() {
        const normalized = this.normalizeProgramSearchText(this.programSearchApplied);
        if (!normalized) return this.programOptions;
        const terms = normalized.split(' ').filter(Boolean);
        if (!terms.length) return this.programOptions;
        return this.programOptions.filter((option) => {
          const haystack = option && option.searchBlob ? option.searchBlob : '';
          return terms.every((term) => haystack.includes(term));
        });
      },
    },

    created () {
      this.$_getLists();// gets dropdown lists and put in store for getter in computed $_lists
      this.getItemsForThisFirm(this.firm.fid);
    },

    watch: {
      carrier() {
        this.filterPolicies();
      },
      type() {
        this.filterPolicies();
      },
      status() {
        if (this.statusSelected) {
          this.view = undefined;
          this.statusSelected = false;
        }
        this.filterPolicies();
      },
      mode() {
        switch(this.mode) {
          case 'More':
            // convert layout to show dropdowns
            this.tableClass = !this.notPopup ? 'popupLargePoliciesTableNoFooter' : 'largeSizePoliciesTableNoFooter';
            break;
          default:
            // revert layout to initial
            this.tableClass = !this.notPopup ? 'popupLargeTableNoFooter' : 'largeSizeTableNoFooter';
        }
      },

      view() {
        this.updateTableView();
      },
      'policyToCreate.prid': function(newPrid) {
        this.loadSelectedProgram(newPrid);
      },
      programMenuOpen(newOpen) {
        if (newOpen) {
          this.onProgramFieldInteract();
          this.syncProgramActiveIndex();
          return;
        }
        const selectedText = this.selectedProgramOption ? this.selectedProgramOption.text : '';
        this.programSearchRaw = selectedText || this.programSearchRaw;
        this.programSearchApplied = '';
      },
      programSearchApplied() {
        this.syncProgramActiveIndex();
      },
      'policyToCreate.incept': function(newIncept) {
        // 12 Feb 2026 JCH: incept edits drive retro/expiry defaults unless manually overridden.
        this.applyInceptDefaults(newIncept);
      },
    },

    methods: {
      openCreatePolicyDialog() {
        if (!this.$_can('policy-edit')) return;
        const today = moment().format('MM-DD-YYYY');
        this.policyToCreate = { prid: null, incept: today, expiry: null, retro: null };
        this.createPolicyManual = { expiry: false, retro: false };
        this.applyInceptDefaults(today);
        this.programsByPrid = {};
        this.selectedProgram = null;
        this.programSearchRaw = '';
        this.programSearchApplied = '';
        this.programMenuOpen = false;
        this.programActiveIndex = -1;
        this.refreshCreatePolicy = !this.refreshCreatePolicy;
        this.createPolicyDialog = true;
      },

      loadProgramOptions() {
        if (this.programsLoaded || this.programsLoading) return;
        this.programsLoading = true;
        programsAPIService.getPrograms(this.$router).then((programs) => {
          const uniquePrograms = [];
          const seen = new Set();
          for (const program of this.normalizePrograms(programs)) {
            if (!program || program.prid === null || program.prid === undefined) continue;
            const typeText = (program.type || '').toString().trim();
            const carrierText = (program.carrier || '').toString().trim();
            if (!typeText || !carrierText) continue;
            if (!/[A-Za-z]/.test(typeText) || !/[A-Za-z]/.test(carrierText)) continue;
            const mgaCidSort = this.getMgaCidSort(program);
            const proidCidSort = this.getProidCidSort(program);
            const searchBlob = this.normalizeProgramSearchText([
              program.prid,
              program.type,
              mgaCidSort,
              program.carrier,
              proidCidSort,
              program.plan,
            ].join(' '));
            if (searchBlob.includes('fdc')) continue; // exclude FDC rows before option build
            if (seen.has(program.prid)) continue;
            seen.add(program.prid);
            uniquePrograms.push({ ...program, searchBlob });
            this.programsByPrid[program.prid] = program;
          }
          uniquePrograms.sort((a, b) => this.compareProgramsForPicker(a, b));
          this.programOptions = uniquePrograms.map((program) => ({
            text: this.programOptionText(program),
            value: program.prid,
            hasMarkup: this.hasAllowedProgramTag(program.plan),
            searchBlob: program.searchBlob
          }));
          this.programsLoaded = true;
        }).catch((error) => {
          this.errors.push(error);
        }).finally(() => {
          this.programsLoading = false;
          if (this.keepProgramMenuOpenAfterLoad) {
            this.programMenuOpen = true;
            this.keepProgramMenuOpenAfterLoad = false;
          }
          if (this.programMenuOpen) this.syncProgramActiveIndex();
        });
      },

      loadSelectedProgram(prid) {
        if (!prid) {
          this.selectedProgram = null;
          if (!this.programMenuOpen) this.programSearchRaw = '';
          return;
        }
        const selectedOption = this.programOptions.find((option) => option.value === prid);
        if (selectedOption) this.programSearchRaw = selectedOption.text;
        if (this.programsByPrid[prid]) this.selectedProgram = this.programsByPrid[prid];
        programsAPIService.getProgram(prid, this.$router).then((program) => {
          this.selectedProgram = program || null;
        }).catch(() => {
          this.selectedProgram = null;
        });
      },

      onProgramFieldInteract() {
        if (!this.programsLoaded) this.keepProgramMenuOpenAfterLoad = true;
        this.programMenuOpen = true;
        this.loadProgramOptions();
      },

      onProgramSearchInput(value) {
        const typed = typeof value === 'string' ? value : '';
        this.programSearchRaw = typed;
        if (this.selectedProgramOption && typed !== this.selectedProgramOption.text) {
          this.policyToCreate.prid = null;
        }
        this.debounceVirtualPickerSearch(() => {
          this.programSearchApplied = typed;
        }, 90);
      },

      onProgramArrow(step) {
        if (!this.programMenuOpen) {
          this.onProgramFieldInteract();
          return;
        }
        const count = this.filteredProgramOptions.length;
        if (!count) return;
        const start = this.programActiveIndex < 0 ? (step > 0 ? -1 : count) : this.programActiveIndex;
        this.programActiveIndex = this.clampVirtualPickerIndex(start + step, count);
        this.$nextTick(() => this.ensureProgramActiveVisible());
      },

      onProgramEnter() {
        if (!this.programMenuOpen) {
          this.onProgramFieldInteract();
          return;
        }
        const option = this.filteredProgramOptions[this.programActiveIndex];
        if (!option) return;
        this.selectProgramOption(option);
      },

      selectProgramOption(option) {
        if (!option) return;
        this.policyToCreate.prid = option.value;
        this.programSearchRaw = option.text;
        this.programSearchApplied = '';
        this.keepProgramMenuOpenAfterLoad = false;
        this.programMenuOpen = false;
      },

      clearProgramSelection() {
        this.policyToCreate.prid = null;
        this.selectedProgram = null;
        this.programSearchRaw = '';
        this.programSearchApplied = '';
        this.keepProgramMenuOpenAfterLoad = false;
        this.programActiveIndex = -1;
        this.programMenuOpen = false;
      },

      syncProgramActiveIndex() {
        const list = this.filteredProgramOptions;
        if (!list.length) {
          this.programActiveIndex = -1;
          return;
        }
        if (this.policyToCreate && this.policyToCreate.prid) {
          const selectedIndex = list.findIndex((option) => option.value === this.policyToCreate.prid);
          if (selectedIndex > -1) {
            this.programActiveIndex = selectedIndex;
            this.$nextTick(() => this.ensureProgramActiveVisible());
            return;
          }
        }
        this.programActiveIndex = 0;
      },

      ensureProgramActiveVisible() {
        this.ensureVirtualPickerIndexVisible(
          this.$refs.programVirtualScroll,
          this.programActiveIndex,
          this.programOptionHeight,
          this.programVirtualHeight
        );
      },

      onCreateDateInput(field, value) {
        this.createPolicyManual[field] = true;
        this.policyToCreate[field] = value;
      },

      applyInceptDefaults(incept) {
        const parsed = moment(incept, ['MM-DD-YYYY', 'M-D-YYYY'], true);
        if (!parsed.isValid()) return;
        const inceptFormatted = parsed.format('MM-DD-YYYY');
        const expiryFormatted = parsed.clone().add(1, 'year').format('MM-DD-YYYY');
        // 12 Feb 2026 JCH: auto-fill retro=incept and expiry=+1y unless user edited those fields.
        if (!this.createPolicyManual.retro) this.policyToCreate.retro = inceptFormatted;
        if (!this.createPolicyManual.expiry) this.policyToCreate.expiry = expiryFormatted;
      },

      isValidCreateDate(date) {
        return moment(date, 'MM-DD-YYYY', true).isValid()
          || moment(date, 'M-D-YYYY', true).isValid();
      },

      normalizePrograms(programs) {
        if (Array.isArray(programs)) return programs;
        if (!programs || typeof programs !== 'object') return [];
        const likelyArrays = ['programs', 'rows', 'items', 'results', 'data'];
        for (const key of likelyArrays) {
          if (Array.isArray(programs[key])) return programs[key];
        }
        for (const key of Object.keys(programs)) {
          if (Array.isArray(programs[key])) return programs[key];
        }
        return [];
      },

      compareProgramsForPicker(a, b) {
        const typeA = (a.type || '').toString().toUpperCase();
        const typeB = (b.type || '').toString().toUpperCase();
        if (typeA < typeB) return -1;
        if (typeA > typeB) return 1;

        const carrierA = (a.carrier || '').toString().toUpperCase();
        const carrierB = (b.carrier || '').toString().toUpperCase();
        if (carrierA < carrierB) return -1;
        if (carrierA > carrierB) return 1;

        const mgaSortA = this.getMgaCidSort(a).toUpperCase();
        const mgaSortB = this.getMgaCidSort(b).toUpperCase();
        if (mgaSortA < mgaSortB) return -1;
        if (mgaSortA > mgaSortB) return 1;

        return Number(a.prid) - Number(b.prid);
      },

      getMgaCidSort(program) {
        if (!program || !program.mgaid || !this.$_lists || !Array.isArray(this.$_lists.cid)) return '';
        const mgaId = Number(program.mgaid);
        const contact = this.$_lists.cid.find((item) => Number(item.value || item.cid) === mgaId);
        return contact ? (contact.sort || contact.text || '') : '';
      },

      getProidCidSort(program) {
        if (!program || !program.proid || !this.$_lists || !Array.isArray(this.$_lists.cid)) return '';
        const proId = Number(program.proid);
        const contact = this.$_lists.cid.find((item) => Number(item.value || item.cid) === proId);
        return contact ? (contact.sort || contact.text || '') : '';
      },

      programOptionText(program) {
        const labels = [];
        if (program.type) labels.push(program.type);
        const mgaCidSort = this.getMgaCidSort(program);
        if (mgaCidSort) labels.push(mgaCidSort);
        if (program.carrier) labels.push(program.carrier);
        const proidCidSort = this.getProidCidSort(program);
        if (proidCidSort) labels.push(proidCidSort);
        if (program.plan) labels.push(program.plan);
        if (!labels.length) labels.push(String(program.prid));
        return labels.join('  ');
      },

      normalizeProgramSearchText(value) {
        return String(value || '')
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, ' ')
          .trim();
      },

      hasAllowedProgramTag(value) {
        return /<\s*\/?\s*b\b[^>]*>?/i.test(String(value || ''));
      },

      escapeHtml(value) {
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      },

      escapeRegExp(value) {
        return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      },

      sanitizeProgramOptionHtml(value) {
        // Normalize loose opening "<b" tokens first, then allow only <b> tags.
        const normalized = String(value || '').replace(/<\s*b(?![^>]*>)/gi, '<b>');
        return this.escapeHtml(normalized)
          .replace(/&lt;\s*b\b[^&]*&gt;/gi, '<b>')
          .replace(/&lt;\s*\/\s*b\s*&gt;/gi, '</b>');
      },

      highlightProgramPlainText(sourceText, terms) {
        const raw = String(sourceText || '');
        if (!terms || !terms.length) return this.escapeHtml(raw);
        const alternation = terms.map((term) => this.escapeRegExp(term)).join('|');
        if (!alternation) return this.escapeHtml(raw);
        const regex = new RegExp(`(${alternation})`, 'ig');
        return raw
          .split(regex)
          .map((part, index) => {
            const escapedPart = this.escapeHtml(part);
            return index % 2 === 1
              ? `<span class="program-picker-match">${escapedPart}</span>`
              : escapedPart;
          })
          .join('');
      },

      highlightProgramOption(option) {
        const sourceText = option && option.text ? option.text : '';
        const hasMarkup = !!(option && option.hasMarkup);
        const normalized = this.normalizeProgramSearchText(this.programSearchApplied);
        const html = hasMarkup
          ? this.sanitizeProgramOptionHtml(sourceText)
          : this.escapeHtml(sourceText);
        if (!normalized) return html;
        if (hasMarkup) return html; // keep existing safe markup intact; avoid wrapping matches inside tags
        const terms = Array.from(new Set(normalized.split(' ').filter(Boolean)))
          .sort((a, b) => b.length - a.length);
        return this.highlightProgramPlainText(sourceText, terms);
      },

      programOptionNeedsHtml(option) {
        if (option && option.hasMarkup) return true;
        return !!this.normalizeProgramSearchText(this.programSearchApplied);
      },

      createPolicy() {
        if (!this.$_can('policy-edit')) {
          this.$store.dispatch('SET_SNACK', {
            cmpnt: 'FirmPoliciesTable',
            open: true,
            color: 'error',
            msg: 'You do not have permission to create policies.'
          });
          return;
        }
        if (!this.canCreatePolicy) return;
        // 12 Feb 2026 JCH: create payload includes dialog fields + initial status: "App"
        const policyData = {
          fid: this.firm.fid,
          prid: this.policyToCreate.prid,
          incept: this.policyToCreate.incept,
          expiry: this.policyToCreate.expiry,
          retro: this.policyToCreate.retro,
          status: 'App',
        };
        // 12 Feb 2026 JCH: carry selected program labels so new row displays type/carrier immediately.
        if (this.selectedProgram && this.selectedProgram.type) policyData.type = this.selectedProgram.type;
        if (this.selectedProgram && this.selectedProgram.carrier) policyData.carrier = this.selectedProgram.carrier;

        policiesAPIService.addPolicy(policyData, this.$router).then((policy) => {
          this.createPolicyDialog = false;
          this.search = '';
          this.view = 'View All';
          this.newPolicyPid = policy && policy.pid ? policy.pid : null;
          // 12 Feb 2026 JCH: keep auto-open, but defer until post-refresh focus/scroll is attempted.
          this.pendingEditPolicyPid = policy && policy.pid ? policy.pid : null;
          this.policyToCreate = {};
          this.getItemsForThisFirm(this.firm.fid);
        });
      },

      focusNewPolicyRow() {
        if (!this.newPolicyPid) return;
        // 12 Feb 2026 JCH: scroll newly created policy into view after table refresh.
        this.$nextTick(() => {
          const table = this.$refs.policiesTable && this.$refs.policiesTable.$el
            ? this.$refs.policiesTable.$el
            : null;
          if (!table) return;
          const row = table.querySelector('.new-policy-highlight');
          if (!row) return;
          row.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      },

      date(date) {// if valid 'YYYY-MM-DD' date return 'DD MMM YYYY', else return original date
        let valid = moment(date, 'YYYY-MM-DD', true).isValid();
        return valid ? moment(date, 'YYYY-MM-DD').format('DD MMM YYYY') : date;
      },

      filterPolicies() {
        // filters by dropdown selections, if no selection then show as if all are selected
        this.policiesFiltered = this.policies.filter(pol =>
          (this.carrier.includes(pol.carrier) || !this.carrier.length)
          && (this.type.includes(pol.type)    || !this.type.length)
          && (this.status.includes(pol.status) || !this.status.length)
        )
      },

      getItemsForThisFirm(id) {
        this.loading = true;
        apiService.getFirmPolicies(id, this.$router).then((policies) => {
          // need to convert dates so they will sort properly
          for (let policy of policies) {
            for (let date of ['incept','expiry','retro']) {
              if (moment(policy[date], 'M-D-YYYY', true).isValid()) {
                policy[date] = moment(policy[date], 'M-D-YYYY').format('YYYY-MM-DD')
              }
            }
          }
          this.policies = policies;
          this.updateTableView();
          this.loading = false;
          this.refresh = !this.refresh;
          this.focusNewPolicyRow();
          if (this.pendingEditPolicyPid) {
            const policyId = this.pendingEditPolicyPid;
            this.pendingEditPolicyPid = null;
            // 12 Feb 2026 JCH: open edit popup after table render cycle so row focus is visible first.
            setTimeout(() => this.$_editPolicy(policyId), 220);
          }
        })
          .catch((error) => {
            this.errors.push(error);
            this.loading = false;
            if (error.response && error.response.status === 401) {
            }
          });
      },

      openCommissionsDialog(policy) {
        this.comPid = policy.pid;
        this.commissionsDialog = true;
      },

      openTaxDialog(policy) {
        this.taxPid = policy.pid;
        this.taxDialog = true;
      },

      policyRowClass(item) {
        return this.newPolicyPid && item && item.pid === this.newPolicyPid ? 'new-policy-highlight' : '';
      },

      rowClick: function (item, row) {
        this.newPolicyPid = null;
        row.select(true);
      },
      
      updateTableView() {// if view changes or policy created 
        this.carrier = [];
        this.type = [];
        if (this.view) this.status = [];
        switch(this.view) {
          case 'Policies':
            this.status = ['Book','dncLost','Lost','Past','Tail'];
            break;
          case 'Quotes':
            this.status = ['Quote','Indicate','Comp'];
            break;
          case 'View':
            this.status = ['Book','dncLost','Lost','Past','Tail',
              'App','BOR','Hold','Indicate','IndiRate','Info','notComp','Quote','Rate','Ready','Refuse','Sent','Submit',
              'Comp','Current','History'];
            break;
          case 'View All':
            this.status = this.statusAllNames;
            break;
        }
      },

      viewPolicy (policy) {
        let baseUrl = window.location.origin;
        const routeQuery = this.$route && this.$route.query;
        const devAllDocs = process.env.NODE_ENV !== 'production' && routeQuery
          && (routeQuery.allDocs === '1' || routeQuery.allDocs === 'true')
          ? '?allDocs=1'
          : '';
        window.open(baseUrl +  '/viewPolicy/' +  policy.pid + devAllDocs, '_blank',
          'resizeable=yes, width=' + (1000)
          + ', left=' + (500)
          + ', top=' + (22)
          + ', height=' + (700));
      },
    },
  }
</script>

<style>
  .lessPadding.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
    padding: 2px;
  }
  .lessPadding.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    padding: 2px;
  }
  tr.v-data-table__selected {
    background: lightgrey !important;
  }
  .new-policy-highlight {
    background: #dcdcdc !important;
  }
  .program-picker-option { min-height: 40px; cursor: pointer; white-space: normal; overflow: visible; text-overflow: clip; word-break: break-word; line-height: 1.2; }
  .program-picker-option > div { width: 100%; }
  .program-picker-menu-content { margin-top: -18px; }
  .program-picker-option--active { background: #f1f1f1; }
  .program-picker-match { background: #e6e6e6; border-radius: 0; padding: 0; font-weight: inherit; }
  .program-picker-field .v-input__icon--append .v-icon { transition: transform 0.16s ease; }
  .program-picker-field--open .v-input__icon--append .v-icon { transform: rotate(180deg); }
  .program-picker-loading-state { min-height: 104px; }
  .program-picker-loading-row { min-height: 72px; font-size: 0.95rem; font-weight: 500; }
  .program-picker-empty-row { min-height: 56px; }
</style>



